/*
  De prijs en de koopknop bijwerken als de bezoeker een variant kiest.

  Zonder dit bestand verspringt de prijs pas na een herlading. Bij één maat per
  parfum ziet niemand dat; zodra er kleding met maten bij komt is het een echte
  fout — iemand kiest een maat, ziet de prijs van een andere en rekent af.

  Het formulier blijft werken zonder JavaScript: de keuzerondjes zetten zelf al
  het juiste variant-id in het formulier. Dit bestand verandert alleen wat de
  bezoeker ziet.

  De prijzen komen als tekst uit Liquid mee, al opgemaakt met de money-filter.
  Zo staat er nooit een bedrag in de verkeerde valuta of met een punt in plaats
  van een komma.
*/
(function () {
  'use strict';

  function start(wortel) {
    var data = wortel.querySelector('[data-variant-data]');
    if (!data) return;

    /*
      De grote prijs staat boven het formulier, niet erin. Zoeken binnen het
      formulier vindt hem dus niet; het bereik is de hele sectie.
    */
    var vlak = wortel.closest('[data-product-root]') || wortel;

    var varianten;
    try {
      varianten = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }
    if (!varianten || !varianten.length) return;

    var prijsvlak = vlak.querySelector('[data-price]');
    var knop = wortel.querySelector('[data-add]');
    var knopprijs = wortel.querySelector('[data-add-price]');
    var knoptekst = wortel.querySelector('[data-add-label]');
    var afrekenen = wortel.querySelector('[data-checkout]');
    var uitverkocht = knop ? knop.getAttribute('data-soldout-label') : '';
    var kopen = knop ? knop.getAttribute('data-add-label-text') : '';

    function zoek(id) {
      for (var i = 0; i < varianten.length; i++) {
        if (String(varianten[i].id) === String(id)) return varianten[i];
      }
      return null;
    }

    function toon(variant) {
      if (!variant) return;

      if (prijsvlak) prijsvlak.textContent = variant.prijs;

      if (knop) {
        knop.disabled = !variant.beschikbaar;
        if (variant.beschikbaar) {
          /*
            De tekst terugzetten en niet alleen de prijs. Zonder dit blijft het
            woord "Uitverkocht" staan zodra iemand één keer een lege maat heeft
            aangeklikt — met een prijs erachter, op een knop die gewoon werkt.
          */
          if (knoptekst) {
            knoptekst.hidden = false;
            if (kopen) knoptekst.textContent = kopen;
          }
          if (knopprijs) {
            knopprijs.hidden = false;
            knopprijs.textContent = ' · ' + variant.prijs;
          }
          if (!knoptekst && !knopprijs) knop.textContent = variant.prijs;
        } else {
          /*
            Uitverkocht: de prijs weghalen. "In de winkelwagen · €69,95" op een
            knop die niets doet, is een belofte die de winkel niet nakomt.
          */
          if (knopprijs) knopprijs.hidden = true;
          if (knoptekst) {
            knoptekst.hidden = false;
            if (uitverkocht) knoptekst.textContent = uitverkocht;
          }
        }
      }

      if (afrekenen) afrekenen.hidden = !variant.beschikbaar;

      /*
        Het adres meeschrijven, zodat een gedeelde link dezelfde maat toont.
        replaceState en niet pushState: de terugknop hoort naar de vorige
        pagina te gaan, niet naar de vorige maat.
      */
      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        } catch (e) {
          /* Oude browser: het adres blijft staan, verder werkt alles. */
        }
      }
    }

    wortel.addEventListener('change', function (e) {
      var veld = e.target;
      if (!veld || veld.name !== 'id') return;
      toon(zoek(veld.value));
    });
  }

  /*
    De plakkende koopbalk.

    Staat los van het bovenstaande: een parfum met één variant heeft geen
    variantgegevens, maar wel een koopknop -- en dus ook een balk. Alles wat
    de balk toont, leest hij uit het echte koopblok, zodat er maar één
    waarheid is over prijs, voorraad en keuze.
  */
  function koopbalk(bereik) {
    var balk = (bereik || document).querySelector('[data-pdp-balk]')
      || document.querySelector('[data-pdp-balk]');
    if (!balk || balk.dataset.klaar) return;

    var vlak = document.querySelector('[data-product-root]');
    var knop = vlak ? vlak.querySelector('[data-add]') : null;
    if (!vlak || !knop) return;

    balk.dataset.klaar = '1';

    var balkPrijs = balk.querySelector('[data-balk-prijs]');
    var balkStaat = balk.querySelector('[data-balk-staat]');
    var balkKnop = balk.querySelector('[data-balk-knop]');
    var balkOpties = balk.querySelector('[data-balk-opties]');

    var kopen = knop.getAttribute('data-add-label-text') || '';
    var uitverkocht = knop.getAttribute('data-soldout-label') || '';

    function gekozenVeld() {
      return vlak.querySelector('.pdp__radio:checked');
    }

    function naamVan(veld) {
      if (!veld) return '';
      var etiket = vlak.querySelector('label[for="' + veld.id + '"]');
      var titel = etiket ? etiket.querySelector('.pdp__optiontitle') : null;
      return titel ? titel.textContent.trim() : '';
    }

    /* De rij met varianten. Eén variant betekent niets te kiezen. */
    function vulOpties() {
      if (!balkOpties) return;

      var velden = vlak.querySelectorAll('.pdp__radio');
      if (velden.length < 2) {
        balkOpties.hidden = true;
        return;
      }

      balkOpties.innerHTML = '';

      Array.prototype.forEach.call(velden, function (veld) {
        var etiket = vlak.querySelector('label[for="' + veld.id + '"]');
        var op = etiket ? etiket.classList.contains('pdp__option--op') : false;

        var knopje = document.createElement('button');
        knopje.type = 'button';
        knopje.className = 'pdpbalk__optie';
        knopje.textContent = naamVan(veld);
        knopje.setAttribute('data-balk-optie', veld.value);
        knopje.disabled = op;
        knopje.classList.toggle('is-actief', veld.checked);

        balkOpties.appendChild(knopje);
      });

      balkOpties.hidden = false;
    }

    /* De balk leest af wat het koopblok laat zien; nooit een eigen rekensom. */
    function ververs() {
      var veld = gekozenVeld();
      var prijsvlak = vlak.querySelector('[data-price]');

      if (balkPrijs && prijsvlak) balkPrijs.textContent = prijsvlak.textContent.trim();

      if (balkStaat) {
        var regel = naamVan(veld);
        balkStaat.textContent = knop.disabled ? uitverkocht : regel;
        balkStaat.classList.toggle('is-op', knop.disabled);
      }

      if (balkKnop) {
        balkKnop.textContent = knop.disabled ? uitverkocht : kopen;
        balkKnop.disabled = knop.disabled;
      }

      vulOpties();
    }

    if (balkKnop) {
      balkKnop.addEventListener('click', function () {
        if (!balkKnop.disabled) knop.click();
      });
    }

    /* Kiezen vinkt het echte veld aan; de rest van de pagina volgt vanzelf. */
    if (balkOpties) {
      balkOpties.addEventListener('click', function (e) {
        var knopje = e.target.closest('[data-balk-optie]');
        if (!knopje || knopje.disabled) return;

        var veld = vlak.querySelector('.pdp__radio[value="' + knopje.getAttribute('data-balk-optie') + '"]');
        if (!veld) return;

        veld.checked = true;
        veld.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }

    /* Het koopblok werkt zichzelf bij op change; daarna leest de balk het af. */
    vlak.addEventListener('change', function () {
      window.setTimeout(ververs, 0);
    });

    /*
      In beeld zodra de echte koopknop naar boven uit beeld is. Nadrukkelijk
      niet zolang die knop nog onder het scherm zit: bovenaan de pagina heeft
      de bezoeker de knop nog voor zich, en dan is een tweede knop over het
      beeld heen alleen maar drukte.
    */
    balk.hidden = false;

    var wacht = false;

    function meet() {
      var voorbij = knop.getBoundingClientRect().bottom < 0;
      balk.classList.toggle('is-zichtbaar', voorbij);
      vlak.classList.toggle('pdp--balk', voorbij);
    }

    function plan() {
      if (wacht) return;
      wacht = true;
      window.requestAnimationFrame(function () {
        wacht = false;
        meet();
      });
    }

    window.addEventListener('scroll', plan, { passive: true });
    window.addEventListener('resize', plan);
    window.addEventListener('load', meet);

    ververs();
    meet();
  }

  /*
    De beschrijving: drie zinnen, dan "Lees meer". Dezelfde werking als op
    de kledingpagina (kledingblok.js); alleen de haken heten hier anders.

    Op zinnen en niet op regels, want zo vroeg de eigenaar het, en een regel
    afknippen laat een halve zin staan. De tekst komt uit de producteditor en
    kan vet, cursief en meerdere alinea's bevatten. Daarom wordt er niets
    verplaatst of opnieuw opgebouwd: na de derde zin gaat alles op verborgen,
    en "Lees meer" zet het weer aan. De opmaak blijft precies zoals hij was.

    Een zin eindigt op . ! of ? gevolgd door witruimte en een hoofdletter,
    cijfer of aanhalingsteken -- of op het eind van een alinea. "o.a. de" en
    "1.5 cm" tellen dus niet als einde.
  */
  var ZINNEN = 3;
  var BLOK = /^(P|LI|H[1-6]|BLOCKQUOTE|DIV|UL|OL)$/;

  function leesMeer(wortel) {
    var vak = wortel.querySelector('[data-pdp-intro]');
    var knop = wortel.querySelector('[data-pdp-leesmeer]');
    if (!vak || !knop || vak.hasAttribute('data-ingekort')) return;
    vak.setAttribute('data-ingekort', '');

    /*
      Alle tekst achter elkaar, met een regeleinde tussen alinea's en op elke
      <br>. Zonder dat plakt "look.<br>Noble" aan elkaar tot "look.Noble" en
      ziet niemand daar een zinseinde in.
    */
    var stukken = [];
    var alles = '';
    var vorigBlok = null;
    var grens = false;
    var loper = document.createTreeWalker(vak, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT, null);
    while (loper.nextNode()) {
      var knoop = loper.currentNode;
      if (knoop.nodeType === 1) {
        if (knoop.nodeName === 'BR') grens = true;
        continue;
      }
      if (!knoop.textContent.trim()) continue;

      var blok = knoop.parentNode;
      while (blok !== vak && !BLOK.test(blok.nodeName)) blok = blok.parentNode;
      if (stukken.length && (grens || blok !== vorigBlok)) alles += String.fromCharCode(10);
      vorigBlok = blok;
      grens = false;

      stukken.push({ knoop: knoop, begin: alles.length });
      alles += knoop.textContent;
    }

    var einde = /[.!?…]+["'”’)]*(?=\s+["'“‘(]?[A-ZÀ-Þ0-9]|\s*$)/g;
    var snede = -1;
    var gevonden = 0;
    var m;
    while ((m = einde.exec(alles))) {
      gevonden++;
      if (gevonden === ZINNEN) {
        snede = m.index + m[0].length;
        break;
      }
    }

    /* Drie zinnen of minder, of niets meer na de derde: niets in te korten. */
    if (snede < 0 || !alles.slice(snede).trim()) return;

    var plek = null;
    for (var i = stukken.length - 1; i >= 0; i--) {
      if (stukken[i].begin <= snede) {
        plek = stukken[i];
        break;
      }
    }
    if (!plek) return;

    var snijknoop = plek.knoop;
    var binnen = snede - plek.begin;
    if (binnen < snijknoop.textContent.length) snijknoop.splitText(binnen);

    var verborgen = [];

    function verberg(n) {
      if (n.nodeType === 3) {
        if (!n.textContent.trim()) return;
        var omhulsel = document.createElement('span');
        omhulsel.hidden = true;
        n.parentNode.insertBefore(omhulsel, n);
        omhulsel.appendChild(n);
        verborgen.push(omhulsel);
      } else if (n.nodeType === 1) {
        n.hidden = true;
        verborgen.push(n);
      }
    }

    /* Alles na de snede, op elk niveau van binnen naar buiten. */
    for (var x = snijknoop; x && x !== vak; x = x.parentNode) {
      var zus = x.nextSibling;
      while (zus) {
        var volgende = zus.nextSibling;
        verberg(zus);
        zus = volgende;
      }
    }

    knop.hidden = false;
    knop.setAttribute('aria-expanded', 'false');
    knop.addEventListener('click', function () {
      verborgen.forEach(function (n) { n.hidden = false; });
      knop.setAttribute('aria-expanded', 'true');
      knop.hidden = true;
    });
  }

  function init(bereik) {
    var wortels = (bereik || document).querySelectorAll('[data-product-root]');
    for (var j = 0; j < wortels.length; j++) leesMeer(wortels[j]);

    var vlakken = (bereik || document).querySelectorAll('[data-product-form]');
    for (var i = 0; i < vlakken.length; i++) start(vlakken[i]);
    koopbalk(bereik);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  /* De theme editor voegt een sectie opnieuw in zonder de pagina te herladen. */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
